"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = require("../../theme");

var _antd = require("antd");

var _excluded = ["dataSource", "columns", "pagination", "size", "title", "expandable", "rowSelection", "className", "showHeader"];

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AppTable = (0, _styledComponents.default)(_antd.Table)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.table-primary {\n    .ant-table-thead {\n      & > {\n        tr {\n          & > {\n            th {\n              background: ", ";\n              border: 0;\n              font-size: ", ";\n              color: ", ";\n              font-family: \"Inter Regular\";\n              line-height: 13px;\n            }\n          }\n        }\n      }\n      .ant-table-column-sorter {\n        margin-left: 8px;\n        display: flex;\n        align-items: center;\n        min-height: 36px;\n      }\n      .ant-table-column-sorter-up,\n      .ant-table-column-sorter-down {\n        font-size: 9px;\n      }\n      .ant-table-column-sorter-inner {\n        margin-top: 5px;\n      }\n    }\n    .ant-table {\n      &.ant-table-middle {\n        .ant-table-thead {\n          .ant-table-column-sorters {\n            padding: 0 9px;\n          }\n        }\n      }\n    }\n    .ant-table-tbody {\n      & > {\n        tr {\n          &:hover {\n            td {\n              background: ", ";\n            }\n          }\n          & > {\n            td {\n              padding: 19px 16px;\n              font-size: ", ";\n              color: ", ";\n              line-height: 24px;\n              border-bottom-color: ", ";\n              &.ant-table-row-expand-icon-cell {\n                padding: 19px 16px 19px 32px;\n              }\n            }\n          }\n        }\n      }\n    }\n    .ant-table-row-expand-icon {\n      height: 19px;\n      width: 19px;\n      line-height: 19px;\n      &::after,\n      &::before {\n        background: ", ";\n      }\n      ::before {\n        top: 8px;\n      }\n      ::after {\n        left: 8px;\n      }\n      :focus,\n      :hover {\n        color: ", ";\n      }\n    }\n  }\n"])), _theme.theme.colors.grey_faint, _theme.theme.font_size.size_l, _theme.theme.colors.black_secondary, _theme.theme.colors.transparent, _theme.theme.font_size.size_xl, _theme.theme.colors.black_secondary, _theme.theme.colors.grey, _theme.theme.colors.black_secondary, _theme.theme.colors.blue_primay);

function TableComponent(props) {
  var dataSource = props.dataSource,
      columns = props.columns,
      _props$pagination = props.pagination,
      pagination = _props$pagination === void 0 ? false : _props$pagination,
      _props$size = props.size,
      size = _props$size === void 0 ? "middle" : _props$size,
      _props$title = props.title,
      _title = _props$title === void 0 ? null : _props$title,
      _props$expandable = props.expandable,
      expandable = _props$expandable === void 0 ? null : _props$expandable,
      _props$rowSelection = props.rowSelection,
      rowSelection = _props$rowSelection === void 0 ? null : _props$rowSelection,
      className = props.className,
      _props$showHeader = props.showHeader,
      showHeader = _props$showHeader === void 0 ? true : _props$showHeader,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react.default.createElement(AppTable, _extends({
    dataSource: dataSource,
    columns: columns,
    size: size,
    pagination: pagination,
    title: function title() {
      return _title;
    },
    expandable: expandable,
    rowSelection: rowSelection,
    bordered: false,
    className: className,
    showHeader: showHeader
  }, rest));
}

var _default = TableComponent;
exports.default = _default;